
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingpage",
      function () {
        return require("private-next-pages/landingpage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingpage"])
      });
    }
  